export const ACQUIRING_ROUTE_NAMES = {
  paymentsList: 'acquiring.payments',
  balancesList: 'acquiring.balances',
  scoringIndex: 'acquiring.scoring',
  cardScoring: 'acquiring.card-scoring',
  createInvoice: 'acquiring.createInvoice',
  searchClients: 'acquiring.searchClients',
};

export const ADMIN_ROUTE_NAMES = {
  employeesList: 'admin.employees',
  employeesShow: 'admin.employees.show',
  posList: 'admin.pos',
};

export const ALIFSHOP_ROUTE_NAMES = {
  ordersList: 'alifshop.orders',
  ordersShow: 'alifshop.orders.show',
  ordersDeliveryCreate: 'alifshop.orders.delivery.create',
};

export const NASIYA_ROUTE_NAMES = {
  home: 'nasiya.home',
  clientsList: 'nasiya.clients',
  clientsShow: 'nasiya.clients.show',
  clientsSearch: 'nasiya.clients.search',
  clientConfirmAgreement: 'nasiya.clients.confirm-agreement',
  createApplication: 'nasiya.clients.show.create-application',
  clientsUpdateClientPassport: 'nasiya.clients.show.updatePassport',
  clientsCreate: 'nasiya.clients.create',
  clientsNew: 'nasiya.clients.new',
  updateClientPassport: 'nasiya.clients.update-passport',
  applicationsList: 'nasiya.applications',
  applicationsShow: 'nasiya.applications.show',
  applicationsCreateItems: 'nasiya.applications.create.items',
  applicationsCreateConditions: 'nasiya.applications.create.conditions',
  applicationsCreateConfirm: 'nasiya.applications.create.confirm',
  applicationsCreateAgreement: 'nasiya.applications.create.cbAgreement',
  rejectsList: 'nasiya.rejects',
  rejectsShow: 'nasiya.rejects.show',
  rejectsCreate: 'nasiya.rejects.create',
  problemsList: 'nasiya.problems',
  problemsShow: 'nasiya.problems.show',
  deliveriesList: 'nasiya.deliveries',
  deliveriesShow: 'nasiya.deliveries.show',
  deliveriesCreate: 'nasiya.deliveries.create',
  warehouseList: 'nasiya.warehouse',
  warehouseShow: 'nasiya.warehouse.show',
  notificationsList: 'nasiya.notifications',
  calculator: 'nasiya.calculator',
  calculatorPreview: 'nasiya.calculator.preview-payment',
  excelsList: 'nasiya.excels',
  reportsList: 'nasiya.reports',
  salesList: 'nasiya.sales',
  managerApplicationsList: 'nasiya.managerApplications',
  managerApplicationsShow: 'nasiya.managerApplications.show',
  invoiceList: 'nasiya.invoice',
  invoiceListToFsd: 'nasiya.invoice.to-fsd',
  faqList: 'nasiya.faq',
  analyticsList: 'nasiya.analytics',
  qrApplicationsCreate: 'nasiya.qr-applications.create',
  requestsAddItems: 'nasiya.requests.addItems',
  warehouseItemsNew: 'nasiya.warehouse-items.new',
  bonusesIndex: 'nasiya.bonuses.index',
  offerDemandsCreate: 'nasiya.warehouse.offer-demands.create',
  offerDemandsNew: 'nasiya.warehouse.offer-demands.new.to-fsd',
  offerDemandsShowPage: 'nasiya.warehouse.offer-demands.show',
  offerDemandsEditPage: 'nasiya.warehouse.offer-demands.edit',
  offerShowPage: 'nasiya.warehouse.offers.show',
  knowledgeBase: 'nasiya.knowledge-base',
  knowledgeBaseShow: 'nasiya.knowledge-base-show',
  installmentPayment: 'nasiya.installment-payment',
  shipmentOffers: 'nasiya.shipment-offers',
  shipmentOffersCreate: 'nasiya.shipment-offers.create',
  shipmentOffersShow: 'nasiya.shipment-offers.show',
};
